import { Member, PatchOperation } from '@app/_store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MemberActions {
  export class Reset {
    static readonly type = '[MEMBER] Reset';
  }

  export class LoadAll {
    static readonly type = '[MEMBER] Load';
  }

  export class Import {
    static readonly type = '[MEMBER] Import Members';
    constructor(
      public data: FormData,
      public commit: boolean
    ) {}
  }

  export class ClearImport {
    static readonly type = '[MEMBER] Clear Import';
  }

  export class Validate {
    static readonly type = '[MEMBER] Validate';
  }

  export class Update {
    static readonly type = '[MEMBER] Update';
    constructor(
      public member: Member,
      public operations: PatchOperation[] = []
    ) {}

    public set(op: string, path: string, value: unknown): void {
      this.operations.push({
        op,
        path,
        value,
      });
    }
  }

  export class ChangeGroup {
    static readonly type = '[MEMBER] Change Group';
    constructor(
      public memberId: string,
      public fromGroupId: string,
      public toGroupId: string
    ) {}
  }

  export class AddWallet {
    static readonly type = '[MEMBER] Add Wallet';
    constructor(
      public member: Member,
      public initialBalance: number
    ) {}
  }

  export class LoadWalletTransactions {
    static readonly type = '[MEMBER] Load Wallet Transactions';
    constructor(public member: Member) {}
  }

  export class ClearTransactions {
    static readonly type = '[MEMBER] Clear Wallet Transactions';
    constructor(public member: Member) {}
  }

  export class UpdateWalletBalance {
    static readonly type = '[MEMBER] Update Wallet Balance';
    constructor(
      public organizationId: string,
      public memberId: string,
      public groupId: string,
      public newBalance: number
    ) {}
  }

  export class AddWalletTransaction {
    static readonly type = '[MEMBER] Add Wallet Transaction';
    constructor(
      public memberId: string,
      public groupId: string,
      public amount: number,
      public text: string
    ) {}
  }
}
